import React, { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { UseGetLimitsIframe } from '../api/useGetLimitsIframe';
import { Header } from './Header';
import { Loader } from './Loader';
import { Layout } from '../../../components/Layout/Layout';
import { LimitsModal } from '../components/LimitsModal';
import { LimitsSuccessModal } from '../components/LimitsResultModal';
import { useLimitsPageHook } from './useLimitsPageHook';
import { LimitsHigherButton } from '../components/LimitsHigherButton';
import { featureAccess, LimitedFeatureType } from '../../../services/appAccess.service';
import { FeatureAccess } from '../../AccountSettings/components/rolesAndPermissions/PermissionsList';

export const Limits = () => {
  const {
    accountExternalId,
    customerId,
    handleCloseModal,
    handleCloseSucessModal,
    handleOpenLimitsModal,
    handleRequestUpgrade,
    openLimitsModal,
    openSuccessModal,
    requestLoading,
    teirData,
    modalType,
  } = useLimitsPageHook();

  const { t } = useTranslation();
  const { data: iFrameUrl, isLoading, refetch } = UseGetLimitsIframe({ customerId, accountExternalId });
  useEffect(() => {
    refetch();
  }, []);
  const activeComponent = useCallback(() => {
    if (isLoading) {
      return <Loader />;
    }
    return (
      <iframe
        data-testid='limitIframe'
        className='absolute w-full h-full top-[-10px] left-[-24px]'
        title='InvoicePreview'
        src={iFrameUrl}
      />
    );
  }, [isLoading]);

  const isAllowedToUpgradeTier =
    teirData?.canUpgradeToNextTier && featureAccess(null, LimitedFeatureType.InAppLimits) === FeatureAccess.READ_WRITE;

  return (
    <Layout
      wrapperClassName='pt-[100px] pl-[32px] flex flex-col w-full h-full pr-[32px] pb-[20px] ml-[100px] pc-md:ml-[256px]'
      shouldHideChatBot
    >
      <Header headerTitle={t('TRANSACTION_LIMITS')} />
      <div className='bg-bw00 rounded-lg w-full flex flex-col h-full p-[24px]'>
        <div className='flex items-center justify-start'>
          {isAllowedToUpgradeTier && <LimitsHigherButton handleOpenLimitsModal={handleOpenLimitsModal} />}
        </div>
        <div className='w-full h-full relative'>{activeComponent()}</div>
      </div>

      {openLimitsModal && teirData && (
        <LimitsModal
          loadingRequestUpgrade={requestLoading}
          handleRequestUpgrade={handleRequestUpgrade}
          handleCloseModal={handleCloseModal}
          teirData={teirData}
        />
      )}

      {openSuccessModal && <LimitsSuccessModal onSubmit={handleCloseSucessModal} modalType={modalType} />}
    </Layout>
  );
};
